module.exports = __webpack_public_path__ + "static/media/brown_circle.5b177b76.png";